module.exports = __webpack_public_path__ + "img/block_title_01.00751a05.jpg";